var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Author'
      }],
      "title": "All Author"
    }
  }), _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between py-3 px-4"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      "d": "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.author_search,
      expression: "author_search"
    }],
    staticClass: "bg-white rounded-lg py-2 px-11 border w-96",
    attrs: {
      "placeholder": "Search Author Name, Slug"
    },
    domProps: {
      "value": _vm.author_search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.author_search = $event.target.value;
      }, _vm.onSearch]
    }
  }), _vm.author_search ? _c('button', {
    staticClass: "absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.actionReset
    }
  }, [_vm._v(" ✕ ")]) : _vm._e()]), _c('button', {
    staticClass: "text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center",
    attrs: {
      "type": "button"
    }
  }, [_c('router-link', {
    staticClass: "text-white px-1 py-2",
    attrs: {
      "to": {
        path: 'author/create'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New ")])], 1)]), _c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.items,
      "row-key": ['name', 'slug', 'first_name', 'last_name', 'academic_title', 'created', 'modified'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "per-page": 100
    },
    scopedSlots: _vm._u([{
      key: "header-create",
      fn: function (_ref) {
        var column = _ref.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "header-modified",
      fn: function (_ref2) {
        var column = _ref2.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "created",
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(value).time))])];
      }
    }, {
      key: "modified",
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(value).time))])];
      }
    }, {
      key: "actions",
      fn: function (_ref5) {
        var row = _ref5.row;
        return [_c('router-link', {
          staticClass: "link text-gray-600 align-middle items-center flex justify-center",
          attrs: {
            "to": Object.assign({}, _vm.AuthorUpdatePath, {
              params: {
                id: row.id
              }
            })
          }
        }, [_c('svg', {
          staticClass: "w-6 h-6 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
            "clip-rule": "evenodd"
          }
        }), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
            "clip-rule": "evenodd"
          }
        })])])];
      }
    }])
  }), !_vm.isLoading && _vm.items.length ? _c('div', {
    staticClass: "flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }